class Chtinfo {
    constructor() {
        this.chtInfo = [
            {
                tribe:"kamael",
                property:[
                    {
                        gender:"male",
                        job:["warrior"]

                    },
                    {
                        gender:"female",
                        job:["warrior"]
                    }
                ]
            },
            {
                tribe:"human",
                property:[
                    {
                        gender:"male",
                        job:["death", "warrior", "wizard"]

                    },
                    {
                        gender:"female",
                        job:["warrior", "wizard"]
                    }
                ]
            },
            {
                tribe:"elf",
                property:[
                    {
                        gender:"male",
                        job:["death", "warrior", "wizard"]

                    },
                    {
                        gender:"female",
                        job:["warrior", "wizard"]
                    }
                ]
            },
            {
                tribe:"dark",
                property:[
                    {
                        gender:"male",
                        job:["death", "warrior", "wizard"]

                    },
                    {
                        gender:"female",
                        job:["warrior", "wizard"]
                    }
                ]
            },
            {
                tribe:"oak",
                property:[
                    {
                        gender:"male",
                        job:["warrior", "wizard"]

                    },
                    {
                        gender:"female",
                        job:["warrior", "wizard"]
                    }
                ]
            },
            {
                tribe:"dwarf",
                property:[
                    {
                        gender:"male",
                        job:["warrior"]

                    },
                    {
                        gender:"female",
                        job:["warrior"]
                    }
                ]
            }
        ]
    };
}

export default Chtinfo;


// WEBPACK FOOTER //
// ./src/js/whoareyou/chtinfo.js